import React from 'react';
import { HStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion.div;

export default function LoadingDots() {
  return (
    <HStack spacing={1}>
      {[0, 1, 2].map((i) => (
        <MotionBox
          key={i}
          style={{
            width: '6px',
            height: '6px',
            backgroundColor: 'white',
            borderRadius: '50%',
          }}
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.3, 1, 0.3],
            y: [0, -3, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            delay: i * 0.3,
            ease: 'easeInOut',
          }}
        />
      ))}
    </HStack>
  );
}
